<template>
  <div class="BoxContent" @touchmove.prevent>
    <div class="boxOne">
      <div class="leftLogo skeleton"></div>
      <div class="rightBox">
        <span class="font1 skeleton"></span>
        <div class="topBox">
          <div class="two skeleton">
            <span class="font2 skeleton"></span>
          </div>
          <span class="font3 skeleton"></span>
        </div>
      </div>
    </div>
    <div class="boxThree">
      <div class="topBox">
        <span class="topImg skeleton"></span>
        <span class="font4 skeleton"></span>
      </div>
      <div class="cBoxYes">
        <span class="font6 skeleton"></span>
      </div>
      <div class="h5Bt skeleton"></div>
      <span class="font4 skeleton"></span>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {}
  },
  mounted() {},
  methods: {},
}
</script>

<style lang="scss" scoped>
.BoxContent {
  display: flex;
  align-items: center;
  flex-direction: column;
  padding: 20px;
  width: 100%;
  height: 100%;
  .boxOne {
    display: flex;
    align-items: center;
    justify-content: center;
    background: #ffffff;
    border-radius: 32px;
    width: 100%;
    padding: 20px;
    height: 88px;
    margin-bottom: 16px;
    .leftLogo {
      width: 32px;
      height: 32px;
      object-fit: cover;
      border-radius: 50%;
    }
    .rightBox {
      margin-left: 12px;
      display: flex;
      flex-direction: column;
      flex: 1;
      .font1 {
        font-weight: 500;
        font-size: 12px;
        color: #2c2c2c;
        line-height: 16px;
        margin-bottom: 1px;
        height: 15px;
        border-radius: 8px;
        @include multiline(1);
      }
      .topBox {
        display: flex;
        align-items: center;
        width: 100%;
        .two {
          flex: 1;
          .font2 {
            font-weight: 400;
            font-size: 10px;
            color: #8a8b92;
            line-height: 14px;
            height: 14px;
            border-radius: 8px;
            @include multiline(1);
          }
        }
        .font3 {
          font-weight: 400;
          font-size: 10px;
          color: #f67942;
          line-height: 14px;
          margin-left: 20px;
          height: 14px;
          width: 24px;
          border-radius: 8px;
          cursor: pointer;
        }
      }
    }
  }
  .boxThree {
    width: 100%;
    height: 226px;
    background: #ffffff;
    border-radius: 32px;
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    padding: 26px 20px 28px 20px;
    .topBox {
      display: flex;
      align-items: center;
      justify-content: center;
      width: 100%;
      margin-bottom: 20px;
      .topImg {
        width: 36px;
        height: 36px;
        border-radius: 8px;
      }
      .font4 {
        font-weight: 500;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 20px;
        margin-left: 12px;
        // max-width: 247px;
        height: 18px;
        border-radius: 8px;
        flex: 1;
        @include multiline(2);
      }
    }
    .cBoxYes {
      width: 100%;
      margin-bottom: 18px;
      background: #f6f6f6;
      border-radius: 25px;
      height: 48px;
      display: flex;
      align-items: center;
      justify-content: flex-end;
      padding-right: 20px;
      .font6 {
        font-weight: 400;
        font-size: 14px;
        color: #2c2c2c;
        line-height: 20px;
        width: 227px;
        margin-right: 6px;
        text-align: center;
        @include multiline(1);
      }
      .copyIcon {
        width: 20px;
        height: 20px;
        cursor: pointer;
      }
    }
    .h5Bt {
      width: 100%;
      height: 48px;
      border-radius: 24px;
    }
  }
}
</style>
